module.exports = __webpack_public_path__ + "static/media/Download.f422e1d2.svg";